import { NavigateFunction } from 'react-router-dom';
import { VenueId } from '../../venues/venues.types';
import { setVenue } from './venue-slice';
import { paths } from '../../routing/path';

export const selectVenue =
    (venueId: VenueId, navigate: NavigateFunction) => (dispatch: any) => {
        dispatch(setVenue(venueId));
        navigate(paths.venues.byId(venueId));
    };
